import React, { FC } from 'react';
import useSetState from 'utils/hooks/useSetState';
import { useUser } from 'modules/user/userSelector';
import { Button, Field, TimeInput } from '@kontentino/ui';
import Modal from './Modal';
import DateUtils from 'app/utils/date';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import SingleDatePicker from 'app/components/datepicker-dropdown/SingleDatePicker';

type Props = {
  initialDate: string | null;
  initialTime: string | null;
  onSubmit(s: FormState): void;
};

export type FormState = {
  date: string | null;
  time: string | null;
};

const EditDateTimeForm: FC<Props> = (props) => {
  const user = useUser();
  const [state, setState] = useSetState<FormState>({
    date: props.initialDate,
    time: props.initialTime,
  });
  const { t } = useTranslation();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit(state);
      }}
    >
      <Modal.Content className="tw-flex tw-items-center tw-gap-6">
        <Field.Group className="tw-flex-1">
          <Field.Label required>{t('date')}</Field.Label>
          <SingleDatePicker
            date={state.date ? dayjs(state.date) : null}
            onChange={(date) => {
              setState({
                date: date ? DateUtils.toDateString(date) : null,
              });
            }}
          />
        </Field.Group>
        <Field.Group className="tw-flex-1">
          <Field.Label required>{t('time')}</Field.Label>
          <TimeInput
            onChange={(time) => setState({ time })}
            value={state.time ?? undefined}
            is12HourFormat={!user.useMeridianTime}
          />
        </Field.Group>
      </Modal.Content>
      <Modal.Footer>
        <Button type="submit">{t('save')}</Button>
      </Modal.Footer>
    </form>
  );
};

export default EditDateTimeForm;
